// extracted by mini-css-extract-plugin
export var askAiIcon = "_mb-9";
export var container = "_mb-0";
export var groupSeparator = "_mb-a";
export var highlight = "_mb-4";
export var resultIcon = "_mb-5";
export var resultItem = "_mb-7";
export var resultSubtitle = "_mb-3";
export var resultTitle = "_mb-2";
export var resultsList = "_mb-1";
export var searchGroup = "_mb-6";
export var selected = "_mb-8";